import { action } from 'mobx';
import type { IBatchStore } from './batch-store-types';
import logger from '../../utils/logger';
import {
  RemoteBatchData,
  RemoteControlEventType,
} from '../../containers/Batch/RemoteBatchController';
import { changeMaterialMidBatch as _changeMaterialMidBatch } from './material-substitution/change-material-mid-batch';
import { IBatchData } from '../../containers/Batch/IBatchData';

export const batchInitMixin = {

  /**
   * Initial data from batch form edit screen
   */
  initData: action(function initData(this: IBatchStore, data: IBatchData) {
    logger.log('initData', data);

    if (!data?.batchSize) {
      const { ticketStore } = this.rootStore;

      if (!data.batchSize) {
        logger.log('no batch size, finishing load...', data.id);
        ticketStore.updateTicketOnBatchEnd(data.ticket ? data.ticket : data);
      }

      return;
    }

    if (this.canSendRemoteInstruction()) {
      this.sendRemoteInstruction(RemoteBatchData(RemoteControlEventType.BATCH, null, data));
      return;
    }

    data = { ...data };
    this.injectCode(this.executeCode);

    this.sendPacInitialCommands()
      .then(() => {
        this.autoBatch(data);
      }).catch(e => {
        logger.warn('CBP error:', e);
        this.showError({ key: 'Plant error', props: { error: e.message }});
      });
  }),

  /**
   * Change batched material mid-batch while preserving correct tracking
   */
  changeMaterialMidBatch: action(function changeMaterialMidBatch(this: IBatchStore, params: any) {
    _changeMaterialMidBatch(this.rootStore, params);
    return true;
  }),

};
